import { createAjaxEpic } from '../utils';
import { search } from './actions';
import { fetchPlaces } from '../Places/actions';
// import { debug } from '../../../utils';
// const log = debug('lego:models/Profile/epics');

import { serializeParams } from '../../../server/api/utils'
const searchUrl = (params) => {
    const query = serializeParams(params);
    return `/api/search${query && '?' + query}`;
};

const completeSearch = search.complete;
search.complete = [
    (payload, params) => completeSearch({
      keyword: params['keyword'],
						places: payload.places,
						sort: params['sort'],
						position: {
								latitude: params['latitude'],
								longitude: params['longitude'],
						},
    }),
    fetchPlaces.complete] as any;
const searchEpic = createAjaxEpic(searchUrl, search);

export { searchEpic };



// WEBPACK FOOTER //
// ./src/app/models/Search/epics.ts